import React from 'react';
import { Row, Col, Divider, List, Spin, Dropdown, Button, Empty } from 'antd';
import { CloseCircleOutlined, DownCircleOutlined, EditOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import { _fmtRupiah } from '../../../../../lib/Helper';

class Mobile extends React.Component {
  componentDidMount() {
    this.props.fetchTable(true)
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <InfiniteScroll
              dataLength={table.data.length}
              next={this.props.fetchTable}
              hasMore={table.pagination.total != null && table.data.length < table.pagination.total}
              loader={<div style={{ textAlign: "center" }}><Spin size="small" /></div>}
              endMessage={table.loading_first ? "" : (table.data.length ? <Divider /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Data tidak ditemukan" />)}
            >
              <List
                loading={table.loading_first}
                locale={{ emptyText: " " }}
                dataSource={table.data}
                renderItem={(row, i) => (
                  <List.Item
                    key={i}
                  >
                    <List.Item.Meta
                      title={row.nama_item ? row.nama_item : "-"}
                      description={<>
                        <Row gutter={[8, 8]}>
                          <Col xs={24}>
                            <small>
                              Jumlah: {row.jml_item ? row.jml_item : "-"} <br />
                              Satuan: {row.satuan_item ? row.satuan_item : "-"} <br />
                              Harga Satuan: {"Rp. " + (row.hrgsatuan_item ? _fmtRupiah(row.hrgsatuan_item) : "-")} <br />
                              Harga Sub Total: {"Rp. " + (row.hrgsatuan_item ? _fmtRupiah(row.jml_item*row.hrgsatuan_item) : "-")} <br />
                            </small>
                          </Col>
                        </Row>
                      </>}

                    />
                    <div>
                      {(!action.delete && !action.update ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.update ? [{
    key: 1,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.props.modalForm.bind(this, true, row)
  }] : []), ...(action.delete ? [{
    key: 2,
    icon: <CloseCircleOutlined />,
    label: "Delete",
    onClick: this.props.modalDelete.bind(this, true, row)
  }] : [])]
}}>
                        <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                      </Dropdown>)}
                    </div>
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </Col>
        </Row>
      </>
    )
  }
}

export default Mobile;
